import gql from "graphql-tag"

const updateAti = gql`
mutation 
updateAti($data: AtiInput!, $bookingNumber: String!) {
    updateAti(data: $data, bookingNumber: $bookingNumber) {
        UpdatedOk
        ReservationAtiInformation {
            ReservationId
            Nationalities {
                Code
                Name
            }
            Persons {
                ReservationPersonId
                DisplayName
                Values {
                    FieldId
                    Value
                    Key
                    Type
                    ValidationMessageLocalized
                    KeyLocalized
                }
            }
        }
    }
}        
`

export {
    updateAti
}